export const path = {
  HOME: '/',
  ANCHOR_TAG: '#',
  IAM: '/iam',
  LOGIN: '/login',
  LOGIN_REASON: '/loging/:reason',
  FORGOT_PW: '/forgotpw',
  FORGOT_PW_INVALID_CODE: '/forgotpw/invalidcode',
  FORGOT_PW_REQ: '/forgotpw/:req',
  EXPIRED_PW: '/expiredpw',
  SSO_LOGIN: '/ssologin',
  SSO_TID: '/sso/:tid',
  SEND_INVITE: '/invite/:inviteId',
  INVITE: '/invite',
  CONVERSATION: '/conv',
  // Home page after authentication
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  PROFILE_NOTIFICATION: '/profile/:notification',
  CALENDAR_CONNECTED: '/profile/calendarconnected',
  SETTINGS: '/settings',
  SETTINGS_ICIMS: '/settings/icims',
  SETTINGS_GREENHOUSE: '/settings/greenhouse',
  SETTINGS_BULLHORN: '/settings/bullhorn',
  SETTINGS_EMAIL: '/settings/email',
  SETTINGS_CANDIDATE: '/settings/inboundcandidate',
  INBOX: '/inbox',
  INBOX_ID: '/inbox/:type',
  INBOX_CANDIDATE_ID: '/inbox/:type/:candidateId',
  CANDIDATES: '/candidates',
  JOB_CHAT: '/jobchat',
  STARRED: '/starred',
  ATS_CANDIDATE: '/candidates/external/icims',
  CANDIDATES_ADD: '/candidates/action/:action',
  CANDIDATES_EDIT: '/candidates/action/:action/:id',
  CANDIDATES_EXTERNAL: '/candidates/external/:src',
  CANDIDATE: '/candidate/:candidateId',
  CANDIDATE_DOWNLOAD_URL: 'candidate',
  CANDIDATE_DETAIL: '/candidates/:candidateId',
  ADD_CAMPAIGN_TO_CANDIDATE: '/candidates/:candidateId/addcampaign',
  EMPLOYEES: 'employees',
  EMPLOYEE_ADD: '/employees/add',
  EMPLOYEES_EXTERNAL: '/employees/external/:src',
  EMPLOYEES_CANDIDATE: '/employees/:candidateId',
  TEAM_ADD: '/team/add',
  TEAM_EXTERNAL: '/team/external/:src',
  TEAM_CANDIDATE: '/team/:candidateId',
  CAMPAIGNS: '/campaigns',
  CAMPAIGN: '/campaigns/:campaignId',
  CAMPAIGN_DETAIL_ON_NO_NAV_MODE: '/campaigns/:campaignId&noNavMode=true',
  ADD_CANDIDATE_TO_CAMPAIGN: '/campaigns/:campaignId/AddCandidate',
  RE_ENGAGEMENT_CAMPAIGN: '/reengagement/:campaignId',
  TAGS: '/tags',
  TAG: '/tags/:tagId',
  CALENDAR: '/calendar',
  EVENTS: '/events',
  THREAD: '/thread/:threadSelected',
  // BROADCASTS: '/broadcasts', 											TODO: Ask the Hackman
  // BROADCASTS_CAMPAIGN: '/broadcasts/:campaignId',	TODO: Ask the Hackman
  REPORTING: '/reporting',
  DOWNLOADS: '/downloads',
  USERS: '/users',
  USER: '/users/:userId',
  USERS_ADD: '/users/action/:action',
  USERS_EDIT: '/users/action/edit/:id',
  ADD_CAMPAIGN: '/campaign/add',
  EDIT_CAMPAIGN: '/campaigns/edit/:jobId',
  CANDIDATES_ID: '#/candidates/',
  SCHEDULE_MESSAGE: '/scheduleMessage',
  PAGE_SCHEDULE_MESSAGE: '/:page/scheduleMessage',
  SCHEDULE_MESSAGE_WITH_ID: '/:page/:pageId/add/scheduleMessage',
  SCHEDULE_MESSAGE_EDIT: '/:page/:pageId/scheduleMessage/:id',
  SETTINGS_INBOUND_APPLICATIONS: '/settings/inboundApplications',
  SETTINGS_ICIMS_INTEGRATIONS: '/settings/icimsIntegrations',
  SETTINGS_EMAIL_INTEGRATIONS: '/settings/email',
  SETTINGS_GREENHOUSE_INTEGRATIONS: '/settings/greenhouseIntegrations',
  SETTINGS_BULLHORN_INTEGRATIONS: '/settings/bullhornIntegrations',
  REGULATORY_BUNDLES: '/regulatorybundles',
  TEAMS: '/teams',
  TEAM: '/teams/:teamId',
  ADD_TEAM: '/teams/action/add',
  EDIT_TEAM: '/teams/action/edit/:teamId',
  EDIT_TEAM_USERS: '/teams/action/edit_users/:teamId',
  ADD_TEAM_USERS: '/teams/action/add_users/:teamId',
};
